import { render, staticRenderFns } from "./AreYouSure.vue?vue&type=template&id=2704bc1f&scoped=true"
import script from "./AreYouSure.vue?vue&type=script&lang=js"
export * from "./AreYouSure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2704bc1f",
  null
  
)

export default component.exports